export default "__VITE_ASSET__DoPVA7sV__"